<template>
  <div class="no-permission" style="background-color:#f6f8fa;">
    <div class="content">
      <el-row justify="center">
        <el-image src="/static/images/No_Permission1.png" alt="No Permission"></el-image>
        <div style="font-size:2rem;text-align:center;">您暂无访问权限</div>
      </el-row>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "NoPermission",
  methods: {
    goHome() {
      this.$router.push("/index");
    }
  }
};
</script>
  
  <style scoped>
.no-permission {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;
}
.box-card {
  width: 400px;
  text-align: center;
}
.message {
  margin: 20px 0;
}
.actions > .el-button {
  margin: 0 10px;
}
</style>
  


// WEBPACK FOOTER //
// src/view/no.vue